import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";

import CardLayout from "../../../components/utils/CardLayout";
import Button from "../../../components/utils/Button";

import ActivationStatusAction from "../../../redux/activationStatus/actions";

const { getActivationStatus } = ActivationStatusAction;

function ActivationStatus() {

    const dispatch = useDispatch();

    const {
        activationStatusResult,
        activationStatusLoading
    } = useSelector(
        (state) => state.activationStatus
    );

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm();

    const [serialNo, setSerialNo] = useState("");

    const handleSearch = (data) => {

        setSerialNo(data.serialNumber);

        dispatch(
            getActivationStatus({
                serialNumber: data.serialNumber
            })
        );
    };

    const activationData = Array.isArray(activationStatusResult)
        ? activationStatusResult
        : [];

    const item = activationData.length > 0
        ? activationData[0]
        : null;

    const isSuccess =
        item &&
        item.Status &&
        item.Status.toUpperCase() === "SUCCESS";

    return (
        <CardLayout title="Activation Status">

            {/* ================= SEARCH ================= */}

            <div className="search-email-box iq-card-body">

                <form onSubmit={handleSubmit(handleSearch)}>

                    <div className="form-row">

                        <div className="col-lg-4">

                            <label>
                                Serial Number
                            </label>

                            <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Serial Number"
                                {...register("serialNumber", {
                                    required:
                                        "Serial Number is required"
                                })}
                            />

                            {errors.serialNumber && (
                                <div className="invalid-feedback d-block">
                                    {errors.serialNumber.message}
                                </div>
                            )}

                        </div>

                        <div className="col-lg-6 mt-4 ml-0 pl-0">

                            <div
                                className="col-md-12"
                                style={{
                                    marginTop: "7px"
                                }}
                            >

                                <Button
                                    title="Search"
                                    style="minWidth:80px"
                                    buttonClass="btn btn-primary"
                                    loading={activationStatusLoading}
                                    buttonType="submit"
                                />

                            </div>

                        </div>

                    </div>

                </form>

            </div>


            {/* ================= LOADING ================= */}

            {activationStatusLoading && (
                <div className="text-center mt-4 mb-4">
                    <span>
                        Loading activation status...
                    </span>
                </div>
            )}


            {/* ================= ACTIVATION CARD ================= */}

            {!activationStatusLoading &&
                serialNo &&
                item && (

                    <div className="row mt-4">

                        <div className="col-7">

                            <div
                                className="card"
                                style={{
                                    borderRadius: "10px",
                                    border: "1px solid #e5e5e5",
                                    boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
                                }}
                            >

                                <div
                                    className="card-body"
                                    style={{
                                        padding: "18px 22px"
                                    }}
                                >

                                    {/* HEADER */}

                                    <div
                                        className="d-flex justify-content-between align-items-center mb-3"
                                    >

                                        <h5
                                            className="mb-0"
                                            style={{
                                                fontSize: "17px",
                                                fontWeight: "600"
                                            }}
                                        >
                                            Activation Details
                                        </h5>

                                        <span
                                            className={
                                                isSuccess
                                                    ? "badge badge-success"
                                                    : "badge badge-warning"
                                            }
                                            style={{
                                                padding: "6px 12px",
                                                fontSize: "11px",
                                                borderRadius: "15px"
                                            }}
                                        >
                                            {isSuccess
                                                ? "SUCCESS"
                                                : "PENDING"}
                                        </span>

                                    </div>


                                    {/* DETAILS */}

                                    <div className="row">

                                        {/* BatchTxnId */}

                                        <div className="col-lg-4 col-md-6 mb-3">

                                            <small className="text-muted">
                                                Batch Transaction ID
                                            </small>

                                            <div
                                                style={{
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    marginTop: "4px"
                                                }}
                                            >
                                                {item.BatchTxnId || "-"}
                                            </div>

                                        </div>


                                        {/* TransactionId */}

                                        <div className="col-lg-4 col-md-6 mb-3">

                                            <small className="text-muted">
                                                Transaction ID
                                            </small>

                                            <div
                                                style={{
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    marginTop: "4px"
                                                }}
                                            >
                                                {item.TransactionId || "-"}
                                            </div>

                                        </div>


                                        {/* Serial Number */}

                                        <div className="col-lg-4 col-md-6 mb-3">

                                            <small className="text-muted">
                                                Serial Number
                                            </small>

                                            <div
                                                style={{
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    marginTop: "4px",
                                                    wordBreak: "break-all"
                                                }}
                                            >
                                                {item.SerialNumber || "-"}
                                            </div>

                                        </div>


                                        {/* MSISDN */}

                                        <div className="col-lg-4 col-md-6 mb-3">

                                            <small className="text-muted">
                                                MSISDN
                                            </small>

                                            <div
                                                style={{
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    marginTop: "4px"
                                                }}
                                            >
                                                {isSuccess
                                                    ? item.MSISDN || "-"
                                                    : "-"}
                                            </div>

                                        </div>


                                        {/* Processed Time */}

                                        <div className="col-lg-4 col-md-6 mb-3">

                                            <small className="text-muted">
                                                Processed Time
                                            </small>

                                            <div
                                                style={{
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    marginTop: "4px"
                                                }}
                                            >
                                                {isSuccess &&
                                                    item.ProcessedDtTm
                                                    ? new Date(
                                                        item.ProcessedDtTm
                                                    ).toLocaleString()
                                                    : "-"}
                                            </div>

                                        </div>


                                        {/* Submitted Time */}

                                        <div className="col-lg-4 col-md-6 mb-3">

                                            <small className="text-muted">
                                                Submitted Time
                                            </small>

                                            <div
                                                style={{
                                                    fontWeight: "600",
                                                    fontSize: "14px",
                                                    marginTop: "4px"
                                                }}
                                            >
                                                {item.SubmissionDtTm
                                                    ? new Date(
                                                        item.SubmissionDtTm
                                                    ).toLocaleString()
                                                    : "-"}
                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>
                )}


            {/* ================= NO DATA ================= */}

            {!activationStatusLoading &&
                serialNo &&
                !item && (

                    <div className="text-center mt-4 mb-3">

                        <div className="alert alert-info">
                            No activation status found for this Serial Number.
                        </div>

                    </div>

                )}

        </CardLayout>
    );
}

export default ActivationStatus;